import React from 'react';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import ActionButton from '../../../elements/ActionButton/ActionButton';

const DirectoryItemLinks = (props) => {
    const { event, item, onShowMap } = props,
        i18n = useI18n(),
        { exhibitors_map_url } = event,
        links = [];

    if (item.hyperlink) {
        links.push(
            <li key="site">
                <ActionButton href={item.hyperlink} next secondary>
                    {i18n['label.website.visit']}
                </ActionButton>
            </li>
        );
    }

    if (item.withEmail) {
        links.push(
            <li key="email">
                <ActionButton href={'./message'} next secondary>
                    {i18n['label.email.send']}
                </ActionButton>
            </li>
        );
    }

    if (exhibitors_map_url && item.coordinates?.length) {
        links.push(
            <li key="map">
                <ActionButton onClick={onShowMap} next secondary>
                    {i18n['sponsor.view.on.map']}
                </ActionButton>
            </li>
        );
    }

    return <ul className="list">{links}</ul>;
};

export default DirectoryItemLinks;
